import { useRevealAll } from '../hooks/useReveal';

export default function HekaAI() {
  const containerRef = useRevealAll();

  return (
    <section className="section ai-section" id="ai" ref={containerRef}>
      <div className="ai-inner">
        {/* Chat mock-up */}
        <div className="ai-visual reveal">
          <div className="ai-chat-header">
            <div className="ai-avatar">{'\u2695'}</div>
            <div>
              <div className="ai-name">Heka AI</div>
              <div className="ai-status">{'\u25CF'} Active</div>
            </div>
            <div style={{ marginLeft: 'auto', fontSize: 11, color: 'var(--heka-gray-400)' }}>
              Clinical Assistant
            </div>
          </div>

          <div className="chat-bubble bubble-user">
            Patient presenting with 3-day fever, headache, and joint pain. Lives near water body.
          </div>

          <div className="chat-bubble bubble-heka">
            <strong>Differential Considerations:</strong>
            <br />
            1. Malaria (Plasmodium falciparum) &mdash; HIGH probability. Endemic area, classic presentation.
            <br />
            2. Dengue fever &mdash; Consider given joint pain severity.
            <br />
            3. Typhoid &mdash; Rule out with Widal/blood culture.
            <br /><br />
            <strong>Suggested orders:</strong> Malaria RDT, FBC, LFT. Consider empirical
            artemisinin-based therapy pending results. {'\u2713'} Consistent with Ghana STG 2024.
          </div>

          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <div className="chat-bubble bubble-user" style={{ marginBottom: 0 }}>
              Generate SOAP note from this
            </div>
          </div>

          <div style={{ marginTop: 10 }}>
            <div className="ai-typing">
              <div className="typing-dot" />
              <div className="typing-dot" />
              <div className="typing-dot" />
            </div>
          </div>
        </div>

        {/* Feature list */}
        <div className="ai-features">
          <div className="reveal">
            <div className="section-tag">Heka AI</div>
            <h2
              className="section-title"
              style={{ fontSize: 'clamp(24px, 4vw, 38px)', textAlign: 'left', marginBottom: 8 }}
            >
              AI that understands Ghana's healthcare context
            </h2>
            <p style={{ color: 'var(--heka-gray-600)', marginBottom: 24, lineHeight: 1.6 }}>
              Grounded in Ghana Standard Treatment Guidelines, endemic disease patterns, and local
              clinical practice &mdash; not a generic global model.
            </p>
          </div>

          <div className="ai-feature-item reveal">
            <div className="ai-feat-icon">{'\uD83D\uDCDD'}</div>
            <div>
              <div className="ai-feat-title">Automated SOAP Notes</div>
              <div className="ai-feat-desc">
                Generate complete clinical notes from brief consultation inputs. Clinician reviews,
                edits, and signs.
              </div>
            </div>
          </div>

          <div className="ai-feature-item reveal">
            <div className="ai-feat-icon">{'\uD83D\uDD2C'}</div>
            <div>
              <div className="ai-feat-title">Differential Diagnosis Support</div>
              <div className="ai-feat-desc">
                Evidence-based differential lists with probability rankings based on presenting
                symptoms and vitals.
              </div>
            </div>
          </div>

          <div className="ai-feature-item reveal">
            <div className="ai-feat-icon">{'\uD83D\uDC8A'}</div>
            <div>
              <div className="ai-feat-title">Drug Interaction Checker</div>
              <div className="ai-feat-desc">
                Automatic review of all current medications before new prescriptions. Flags
                contraindications instantly.
              </div>
            </div>
          </div>

          <div className="ai-feature-item reveal">
            <div className="ai-feat-icon">{'\u2764\uFE0F'}</div>
            <div>
              <div className="ai-feat-title">Patient Health Tips</div>
              <div className="ai-feat-desc">
                Personalized daily health advice based on each patient&apos;s vitals, conditions,
                and medication history.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
